// Define a type for each place
type Place = {
  name: string;
  description: string;
  googleMapsUrl: string;
  facilities: string[];
};

// Export the array of places
export const places: Place[] = [
  {
    name: "Camping Muros",
    description: "Camping con vistas al mar y servicios básicos",
    googleMapsUrl: "https://www.google.com/maps/place/42.76061,-9.06225",
    facilities: ["Duchas", "Electricidad", "Lavandería"]
  },
  {
    name: "Camping Fisterra",
    description: "Camping con vistas al mar y servicios básicos",
    googleMapsUrl: "https://www.google.com/maps/place/Camping+Ruta+Finisterre/@42.9441667,-9.2201833,17z",
    facilities: ["Duchas", "Electricidad", "Lavandería"]
  },
  {
    name: "Repsol Muros",
    description: "Gasolinera con tienda y servicios",
    googleMapsUrl: "@https://www.google.com/maps/search/gasolinera+cerca+de+Muros",
    facilities: ["Gasolina", "Diesel", "Tienda"]
  },
  {
    name: "Galp Fisterra",
    description: "Gasolinera con tienda y servicios",
    googleMapsUrl: "@https://www.google.com/maps/search/gasolinera+cerca+de+Fisterra",
    facilities: ["Gasolina", "Diesel", "Tienda"]
  },
  {
    name: "Supermercado Muros",
    description: "Supermercado con productos básicos",
    googleMapsUrl: "@https://www.google.com/maps/search/supermercado+cerca+de+Muros",
    facilities: ["Alimentación", "Bebidas", "Productos básicos"]
  },
  {
    name: "Supermercado Fisterra",
    description: "Supermercado con productos básicos",
    googleMapsUrl: "@https://www.google.com/maps/search/supermercado+cerca+de+Fisterra",
    facilities: ["Alimentación", "Bebidas", "Productos básicos"]
  },
  {
    name: "Playa de San Francisco",
    description: "Playa con bandera azul y servicios",
    googleMapsUrl: "https://www.google.com/maps/place/Playa+de+San+Francisco",
    facilities: ["Socorristas", "Duchas", "Alquiler de lanchas"]
  },
  {
    name: "Playa de Mar de Fora",
    description: "Playa con vistas al océano",
    googleMapsUrl: "https://www.google.com/maps/place/Playa+de+Mar+de+Fora",
    facilities: ["Vistas al océano", "Senderismo"]
  },
  {
    name: "Faro de Fisterra",
    description: "Faro histórico con vistas al océano",
    googleMapsUrl: "https://www.google.com/maps/place/Faro+de+Fisterra",
    facilities: ["Vistas panorámicas", "Senderismo"]
  },
  {
    name: "Playa de Langosteira",
    description: "Playa con bandera azul y servicios",
    googleMapsUrl: "https://www.google.com/maps/place/Playa+de+Langosteira",
    facilities: ["Socorristas", "Duchas", "Alquiler de lanchas"]
  }
]; 